@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Massachusetts</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!--Level_One_Radio-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Medical_Payment_Coverage_DropDown-->
      @if (
        (controls?.length >= 3 && baseRules?.["Select_Medical_Payment_Coverage_DropDown"]?.includes("show")) ||
        baseRules?.["Select_Medical_Payment_Coverage_DropDown"]?.includes("form")
      ) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[2].formControlName)?.value === null ||
                  reactiveForm.get(controls[2].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[2].formControlName)?.touched &&
                  reactiveForm.get(controls[2].formControlName)?.invalid,
                '_ml-xlarge': baseRules.Show_Indent,
              }"
            >
              @if (baseRules?.["SelectMedicalPayment_LevelOne_Radio"]?.includes("show")) {
                <label
                  class="axis-control-label"
                  for="{{ controls[2].formControlName }}"
                  >{{ controls[2].label }}</label
                >
              }
              <axis-dropdown
                [dataProvider]="controls[2].data"
                id="{{ controls[2].formControlName }}"
                formControlName="{{ controls[2].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[2].formControlName)?.touched) {
                @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select an option.</span
                  >
                }
              }
            </div>
          </div>
        </div>
      }
      <!--Reject_LevelOne_Radio Readonly Text-->
      @if ((baseRules?.["Reject_LevelOne_Radio"] || "").includes("readonly")) {
        <div
          class="axis-form-group"
          id="reject_levelone_radio-pdffield-massachusetts"
        >
          <label class="axis-control-label">
            {{ textValues?.Reject_Text }}
          </label>
        </div>
      }
      <!--PIP Coverage Limit Label-->
      <label class="axis-control-label">
        {{ textValues?.PIP_Coverage_Limit }}
      </label>
      <!--PIP Deductible Dropdown-->
      @if (controls?.length >= 2) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  reactiveForm.get(controls[1].formControlName)?.value === null ||
                  reactiveForm.get(controls[1].formControlName)?.value === '',
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
                '_ml-xlarge': baseRules.Show_Indent,
              }"
            >
              <label
                class="axis-control-label"
                for="{{ controls[1].formControlName }}"
                >{{ controls[1].label }}</label
              >
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span
                    class="axis-error-block"
                    role="alert"
                    >Please select an option.</span
                  >
                }
              }
            </div>
          </div>
        </div>
      }
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Massachusetts</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>

      <!--PIP Coverage Limit Label-->
      <label class="axis-control-label">
        {{ textValues?.PIP_Coverage_Limit_No_Deductible }}
      </label>
    </div>
  }
}
